import { createContext } from 'react';

import { CategoricalBarChartData } from '../types/categorical-bar-chart.js';

export const CategoricalBarChartRawDataContext = createContext<
  CategoricalBarChartData[]
>([]);
